import { useEffect, useState } from "react"

// Optional "respond by" deadline attached to an info_request — a plain date
// input plus an optional time input, deliberately kept to native <input>
// elements (no date-picker library) so this one component drops unchanged
// into the three different action-confirm modals it's used from (OR's
// MUI-based ConfirmModal, PO's MUI-based PurchaseConfirmModal, and PR's plain
// pc-modal), none of which share a design system with each other.
//
// Wire format (see buildDeadlineParam): date only -> "yyyy-MM-dd" (BE treats
// that as end of day, VN time); date + time -> "yyyy-MM-ddTHH:mm" (exact
// cutoff). Leaving the date blank sends no deadline at all — this is always
// optional.
export const useDeadlineFields = (resetKey) => {
  const [date, setDate] = useState("")
  const [time, setTime] = useState("")

  // Clear whenever the modal is reopened for a (possibly different) action.
  useEffect(() => {
    setDate("")
    setTime("")
  }, [resetKey])

  return { date, setDate, time, setTime }
}

export const buildDeadlineParam = (date, time) => {
  if (!date) return undefined
  return time ? `${date}T${time}` : date
}

const inputStyle = {
  flex: 1,
  minWidth: 0,
  fontSize: 14,
  padding: "9px 10px",
  border: "1px solid #d2d6da",
  borderRadius: 6,
  fontFamily: "inherit",
  color: "#344767",
  background: "#fff",
}

export const DeadlineField = ({ date, time, onChangeDate, onChangeTime, disabled }) => (
  <div>
    <label
      style={{
        display: "block",
        fontSize: 12.5,
        fontWeight: 600,
        color: "#495057",
        marginBottom: 6,
      }}
    >
      Response deadline (optional)
    </label>
    <div style={{ display: "flex", gap: 8 }}>
      <input
        type="date"
        value={date}
        disabled={disabled}
        onChange={(e) => onChangeDate(e.target.value)}
        style={inputStyle}
      />
      <input
        type="time"
        value={time}
        disabled={disabled || !date}
        onChange={(e) => onChangeTime(e.target.value)}
        style={inputStyle}
      />
    </div>
    <p style={{ fontSize: 11.5, color: "#8392ab", margin: "6px 0 0", lineHeight: 1.4 }}>
      {date
        ? time
          ? `Must respond by ${date} ${time}, or this will be auto-rejected.`
          : `Must respond by end of day ${date}, or this will be auto-rejected.`
        : "Leave blank for no deadline."}
    </p>
  </div>
)

export default DeadlineField
